export enum Company {
  DEFAULT = 'ia',
  IAAH = 'iaah',
  IAGP = 'iagp',
  IAPW = 'iapw',
  INVESTIA = 'investia',
}

export interface CompanyConfig {
  type: Company;
  clientId: string;
  redirectUri: string;
  centralizationPath: string;
  centralizationConfirmationPath: string;
  authorizeCallbackPath: string;
  externalDomain?: string;
  externalLogoffPath?: string;
  loginAppDomain?: string;
}
